import {
  hideLoading,
  showAlert,
  showLoading,
} from "../Actions/GeneralActions";
import Axios from "axios";
import Apis from "../../config/APIs";
import { getHeaders } from "../../utills";
import { getPaymentsList } from "../Actions/PaymentsAction";

export const PaymentsMiddleware = {

  onGetPayments: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const query = new URLSearchParams();
          query.append('limit', params.limit);
          query.append('page', params.page);

          const data = await Axios.get(Apis.get_payments(query.toString()), await getHeaders());

          if (data?.status == 200) {
            resolve(true);
            dispatch(getPaymentsList(data?.data?.data));
          }
        } catch (error) {

          reject(error);
          dispatch(
            showAlert({
              title: "payments list",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },





};
